import type {GameState} from "./game.flow.types";
import type {GameActions} from "./game.flow.actions";
import {SET_LAUNCH_ERROR} from "./game.flow.actions";

export const gameFlowReducer = (state: GameState = {}, action: GameActions) => {
    switch (action.type) {
        case SET_LAUNCH_ERROR:
            return {...state, error: action.payload};
        default:
            return state;
    }
};
